/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2025, Zumper
 * @description AskZoeLoading
 */

import { ZoeSparkle } from '@zcode-ui/icons'
import React from 'react'
import styles from './AskZoeLoading.module.scss'

export const AskZoeLoadingState = () => {
  return (
    <div className="flex gap-2">
      <ZoeSparkle />
      <p className={`body16Md ${styles.text}`}>Ok, I'm searching for you</p>
    </div>
  )
}
